import React, {useEffect, useState} from "react";

import {TabMenu} from "primereact/tabmenu";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import useProjectContext from "../hooks/useProjectContext";
import ProjectDropDown from "./ProjectDropDown";

const Layout = () => {
  const path = useLocation().pathname;
  const [activeIndex, setActiveIndex] = useState(2);
  const { projectId, user } = useProjectContext();

  useEffect(() => {
    switch (path) {
      case `/mdm/${projectId}`:
      case `/mdm/${projectId}/`:
        return setActiveIndex(0);
      case `/mdm/${projectId}/devices`:
        return setActiveIndex(1);
      case `/mdm/${projectId}/analytics`:
        return setActiveIndex(2);
      case `/mdm/${projectId}/jobs`:
        return setActiveIndex(3);
      case `/mdm/${projectId}/map`:
        return setActiveIndex(4);
      case `/mdm/${projectId}/settings`:
        return setActiveIndex(5);
      default:
        return setActiveIndex(10);
    }
  }, [path]);
  
  const navigate = useNavigate();
  const items = [
    {
      label: "Objects",
      icon: "pi pi-list",
      command: () => {
        navigate(`/mdm/${projectId}/`);
      },
    },
    {
      label: "Devices",
      icon: "pi pi-list",
      command: () => {
        navigate(`/mdm/${projectId}/devices`);
      },
    },
    {
      label: "Analytics",
      icon: "pi pi-chart-line",
      command: () => {
        navigate(`/mdm/${projectId}/analytics`);
      },
    },
    {
      label: "Jobs",
      icon: "pi pi-briefcase",
      command: () => {
        navigate(`/mdm/${projectId}/jobs`);
      },
    },
    {
      label: "Map",
      icon: "pi pi-map",
      command: () => {
        navigate(`/mdm/${projectId}/map`);
      },
    },
    {
      label: "Settings",
      icon: "pi pi-cog",
      command: () => {
        navigate(`/mdm/${projectId}/settings`);
      },
    },
  ];

  return (
    <div>
      <div className="flex gap-1">
        {projectId && (
          <TabMenu
            model={items}
            className="flex-1 justify-content-end"
            activeIndex={activeIndex}
            onTabChange={e => setActiveIndex(e.index)}
          />
        )}
        { user?.companyRef && <ProjectDropDown />}
      </div>
      <Outlet />
    </div>
  );
};

export default Layout;
